import router from '../../router';
import jwt_decode from 'jwt-decode';

export default {
    namespaced: true,
    state: {
        authToken: undefined,
        decodedAuthToken: null,
        roles: [
            { name: 'Owner', value: 'owner' },
            { name: 'Admin', value: 'admin' },
            { name: 'Editor', value: 'editor' },
            { name: 'User', value: 'user' },
        ],
        redirect: null
    },
    getters: {
        authToken(state) {
            return state.authToken;
        },
        roles(state) {
            return state.roles;
        },
        redirect(state) {
            return state.redirect;
        },
        decodedAuthToken(state) {
            return state.decodedAuthToken;
        },
        isSuperAdmin(state) {
            return state.decodedAuthToken ? !!state.decodedAuthToken.super : false;
        },
    },
    mutations: {
        setAuthToken(state, token) {
            localStorage.authToken = token;
            state.authToken = token;
            state.decodedAuthToken = jwt_decode(token);
        },
        clearAuthToken(state) {
            localStorage.removeItem('authToken');
            state.authToken = undefined;
            state.decodedAuthToken = null;
        },
        redirect(state, redirect) {
            state.redirect = redirect;
        }
    },
    actions: {
        login({ commit }, redirect = null) {
            commit('redirect', redirect);
            if (router.currentRoute.name === 'Login') router.go();
            router.push('/login');
        },
        signup({ commit }, redirect = null) {
            commit('redirect', redirect);
            router.push('/signup');
        },
        logout({ commit, rootGetters }) {
            commit('clearAuthToken');

            // In embedded mode, notify the parent window instead of redirecting to login
            if (rootGetters['base/isEmbedded']) {
                window.parent.postMessage({ type: 'authexpire' }, '*');
                return;
            }

            location.href = `${rootGetters['base/url']}/login`;
        },
    }
}